import OrderingArrow from "../../../global/OrderingArrow";

export default function ActionItemsTableHeader({
  ordering,
  onOrderingChange,
  showClientColumn,
  showTypeColumn,
}) {
  return (
    <div className="border-1 border-gray flex border-b px-0 py-2 text-left">
      {showClientColumn && (
        <div className="hidden w-1/6 font-bold md:block">
          <h2 className="text-sm">
            Client
            <OrderingArrow
              val="client_name"
              orderingVal={ordering}
              setOrderingVal={onOrderingChange}
              idPrefix="actionable-items-ordering-client"
            />
          </h2>
        </div>
      )}

      {showTypeColumn && (
        <div className="hidden w-1/6 font-bold md:block">
          <h2 className="text-sm">
            Type
            <OrderingArrow
              val="action_type_label"
              orderingVal={ordering}
              setOrderingVal={onOrderingChange}
              idPrefix="actionable-items-ordering-type"
            />
          </h2>
        </div>
      )}

      <div
        className={`font-bold ${showClientColumn || showTypeColumn ? "w-1/6" : "w-1/4"} hidden md:block`}
      >
        <h2 className="text-sm">
          Name
          <OrderingArrow
            val="assigned_name"
            orderingVal={ordering}
            setOrderingVal={onOrderingChange}
            idPrefix="actionable-items-ordering-name"
          />
        </h2>
      </div>

      <div
        className={`font-bold ${showClientColumn || showTypeColumn ? "w-1/6" : "w-1/4"} hidden md:block`}
      >
        <h2 className="text-sm">
          Created By
          <OrderingArrow
            val="created_by_name"
            orderingVal={ordering}
            setOrderingVal={onOrderingChange}
            idPrefix="actionable-items-ordering-created-by"
          />
        </h2>
      </div>

      <div
        className={`block font-bold ${showClientColumn || showTypeColumn ? "w-1/6" : "w-[30%]"}`}
      >
        <h2 className="text-sm">Action</h2>
      </div>

      <div
        className={`font-bold ${showClientColumn || showTypeColumn ? "w-1/6" : "w-[20%]"} hidden md:block`}
      >
        <h2 className="text-sm">
          Due Date{" "}
          <OrderingArrow
            val="due_date"
            orderingVal={ordering}
            setOrderingVal={onOrderingChange}
            idPrefix="actionable-items-ordering-due-date"
          />
        </h2>
      </div>

      <div className="hidden w-[10%] font-bold md:block">&nbsp;</div>
    </div>
  );
}
